import React, { memo } from "react";

import { range } from "src/utils";
import { Icon } from "src/primitives";

import styles from "./style.css";

export const Stars = memo(props => {
  const { count = 5, rating, starWidth = 10, color = "#f5b546" } = props;
  const stars = range(count);

  const height = `${starWidth}px`;
  const width = `${count * starWidth}px`;
  const widthRating = `${rating * starWidth}px`;
  const widthStar = `${starWidth}px`;

  const style = { color, minWidth: widthStar, maxWidth: widthStar, fontSize: widthStar };

  return (
    <div class={styles.container} style={{ height, width }}>
      <div class={styles.stars} style={{ width }}>
        {stars.map(s => (
          <Icon key={s} name="star_rate" style={{ ...style, color: "#eee" }} />
        ))}
      </div>
      <div class={styles.stars} style={{ width: widthRating }}>
        {stars.map(s => (
          <Icon key={s} name="star_rate" style={style} />
        ))}
      </div>
    </div>
  );
});
